import React, { useEffect, useState } from 'react';
export const CountdownTimer: React.FC = () => {
  // Start with 01:26:33 in seconds
  const initialTime = 1 * 3600 + 26 * 60 + 33;
  const [timeLeft, setTimeLeft] = useState(initialTime);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <div className="bg-cream-card py-6 px-4 border-b border-terracotta/10" data-id="element-51">
      <div className="max-w-3xl mx-auto text-center" data-id="element-52">
        <p className="font-sans text-earth-light font-medium mb-3 text-sm md:text-base" data-id="element-53">
          La oferta con los 5 Bonus de Regalo termina en:
        </p>
        <div className="flex justify-center items-center gap-3 md:gap-4" data-id="element-54">
          <TimeUnit value={formatTime(hours)} label="Horas" data-id="element-55" />
          <span className="text-terracotta font-bold text-2xl md:text-3xl pb-5" data-id="element-56">
            :
          </span>
          <TimeUnit value={formatTime(minutes)} label="Minutos" data-id="element-57" />
          <span className="text-terracotta font-bold text-2xl md:text-3xl pb-5" data-id="element-58">
            :
          </span>
          <TimeUnit value={formatTime(seconds)} label="Segundos" data-id="element-59" />
        </div>
      </div>
    </div>;
};
const TimeUnit = ({
  value,
  label
}: {
  value: string;
  label: string;
}) => <div className="flex flex-col items-center" data-id="element-60">
    <div className="bg-white border border-terracotta/20 text-terracotta font-mono font-bold text-2xl md:text-4xl py-2 px-3 md:px-4 rounded-lg shadow-sm min-w-[3rem] md:min-w-[4rem] text-center" data-id="element-61">
      {value}
    </div>
    <span className="text-[10px] md:text-xs font-sans text-earth-light mt-1 uppercase tracking-wider" data-id="element-62">
      {label}
    </span>
  </div>;